<header class="header">
  <inpla-navbar />
</header>
<router-outlet></router-outlet>
